/*
 * @Author: Yun
 * @Date: 2024-02-17 13:53:26
 * @Last Modified by: Yun
 * @Last Modified time: 2024-02-27 17:03:29
 */
import React, { useEffect } from 'react'
import title from '@images/summary/title.png'
import tv from '@images/summary/tv.png'
import CgtnJwplayer from '@components/cgtnJwplayer'
import video from '@videos/summary.mp4'
import './index.less'

const PREFIX = 'summary-page'

const SummaryPage = (props) => {
    const { id } = props

    useEffect(() => {}, [])

    return (
        <section className={PREFIX} id={id}>
            <img className={`${PREFIX}-title`} src={title} alt="" />
            <CgtnJwplayer
                className={`${PREFIX}-tv`}
                id={`${PREFIX}-video`}
                videoUrl={video}
                cover={tv}
            />
        </section>
    )
}

export default SummaryPage
